import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://fiifit.ro';

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// Sleep Logs
export const createSleepLog = async (data: any) => {
  const response = await axios.post(`${API_URL}/api/tracking/sleep`, data, getAuthHeaders());
  return response.data;
};

export const getSleepLogs = async (params?: any) => {
  const response = await axios.get(`${API_URL}/api/tracking/sleep`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

// Pain Logs
export const createPainLog = async (data: any) => {
  const response = await axios.post(`${API_URL}/api/tracking/pain`, data, getAuthHeaders());
  return response.data;
};

export const getPainLogs = async (params?: any) => {
  const response = await axios.get(`${API_URL}/api/tracking/pain`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

// Stress Logs
export const createStressLog = async (data: any) => {
  const response = await axios.post(`${API_URL}/api/tracking/stress`, data, getAuthHeaders());
  return response.data;
};

export const getStressLogs = async (params?: any) => {
  const response = await axios.get(`${API_URL}/api/tracking/stress`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

// Vitals Logs
export const createVitalsLog = async (data: any) => {
  const response = await axios.post(`${API_URL}/api/tracking/vitals`, data, getAuthHeaders());
  return response.data;
};

export const getVitalsLogs = async (params?: any) => {
  const response = await axios.get(`${API_URL}/api/tracking/vitals`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};
